<template>
    <div class="content-block">
        <div class="content-block-box">
            <div>
                <p>
                    <span class="multi-line-overflow">
                        <slot></slot>
                    </span>
                </p>
            </div>
        </div>        
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            list: this.contentList
        }
    },
    props:['contentList'],
    methods: {
        clickLi (term, index) {
            this.$emit('contentTerm',term);
        }
    }
}
</script>

<style lang="scss">
    .content-block-box {
        width: 282px;
        height: 78px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(9, 41, 77, 0.13);            
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        font-size: 18px;
        cursor:pointer;
                
        div {
            width: 222px;
            height: 78px;
            margin-left: 30px;
            line-height: 26px;
            display: table;
            
            p {
                display: table-cell;
                vertical-align: middle;
            }
        }        
    }
</style>